export enum ActionButtonTitle {
  Downgrade = 'Downgrade',
  GetStarted = 'Get started',
  Renew = 'Renew',
  SwitchToAnnual = 'Switch to annual',
  SwitchToMonthly = 'Switch to monthly',
  Upgrade = 'Upgrade',
}
